import { Box, Typography } from '@mui/material';
import BLOG1COVER from "../../assets/blogs/blog 1 - cover image.webp";
import BLOG2COVER from "../../assets/blogs/blog 2 cover image.webp";
import PROJECT1 from "../../assets/blogs/blog 4-cover image.webp";
import PROJECT3 from "../../assets/blogs/Blog 3-cover image-Creative Web App Ideas for Entrepreneurs.webp";
import BLOG5COVER from "../../assets/blogs/Blog 5 cover.webp";
import BLOG6COVER from "../../assets/blogs/Blog 6 - Cover.webp";
import BLOG7COVER from "../../assets/blogs/Blog 7 - Cover.jpg";
import BLOG8COVER from "../../assets/blogs/Blog 8 - Cover.webp";
import BLOG9COVER from "../../assets/blogs/Blog 9 - Cover.webp";
import BLOG10COVER from "../../assets/blogs/Cover images ostryx blog.webp";
import BLOG11COVER from "../../assets/blogs/Blog 11 - Cover.webp";
import BLOG12COVER from "../../assets/blogs/Blog 12 - Cover.jpg";
import BLOG13COVER from "../../assets/blogs/Blog 13 - Cover.webp";
import BLOG14COVER from "../../assets/blogs/Blog 14 - Cover.webp";
import BLOG15COVER from "../../assets/blogs/Blog 15 - Cover.webp";
import BLOG16COVER from "../../assets/blogs/Blog 16 - cover.webp";
import BLOG17COVER from "../../assets/blogs/Blog 17 - Cover.webp";
import BLOG18COVER from "../../assets/blogs/Blog 18 - Cover.webp";

import {useNavigate} from "react-router-dom"

const RecentBlogs = () => {
    const navigate = useNavigate();
    return (
            <Box sx={{ 
                border: '1px solid #e0e0e0',
                borderRadius: '16px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                p: 3,
                backgroundColor: '#ffffff'
            }}>
                <Typography variant="h6" sx={{ mb: 2, color: '#5E17EB', fontWeight: 'bold' }}>
                Recent Blogs
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                
                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/how-to-develop-online-payment-app-usa')}
                >
                    <Box component="img" 
                    src={BLOG18COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    How to Develop an Online Payment App in USA – OSTRYX Insights
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        June 5, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/real-estate-app-development-timeline')}
                >
                    <Box component="img" 
                    src={BLOG17COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    How Long Will It Take to Develop Your Real Estate App? Here's What to Expect From Start to Finish
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        May 29, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/mobile-app-development-trends-dallas')}
                >
                    <Box component="img" 
                    src={BLOG16COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Top 10 Mobile App Development Trends in Dallas – OSTRYX Insights
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        May 26, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/build-real-estate-app-no-code-guide')}
                >
                    <Box component="img" 
                    src={BLOG15COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Build a Real Estate App in 2025 Using No-Code Platforms – Complete Guide
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        May 22, 2025
                    </Typography>
                    </Box>
                </Box>
                
                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/top-mvp-development-companies-usa')}
                >
                    <Box component="img" 
                    src={BLOG14COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    10 Top-Rated MVP Development Companies in USA
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        May 20, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/innovative-mental-health-apps-growth-wellbeing')}
                >
                    <Box component="img" 
                    src={BLOG13COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Top 10 Most-Innovative Mental Health App Ideas for Growth and Well-Being - 2025
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        May 15, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/food-delivery-app-ideas')}
                >
                    <Box component="img" 
                    src={BLOG12COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    15 Food Delivery App Ideas to Start in 2025
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        May 12, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/top-fitness-app-ideas-usa')}
                >
                    <Box component="img" 
                    src={BLOG11COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    10 Top Fitness App Ideas to Launch in the USA in 2025
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        May 8, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/dating-apps-in-usa')}
                >
                    <Box component="img" 
                    src={BLOG10COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Top 10 Dating Apps in USA – 2025 
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        May 5, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/php-vs-javascript-best-tech-stack-scalable-web-app')}
                >
                    <Box component="img" 
                    src={BLOG9COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    PHP vs JavaScript - Choosing the Best Tech Stack for Scalable Web App Development
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 30, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/best-mobile-app-development-tools')}
                >
                    <Box component="img" 
                    src={BLOG8COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Best Mobile App Development Tools - Features, Pros, and Cons
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 28, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/10-must-have-features-successful-mobile-app-usa')}
                >
                    <Box component="img" 
                    src={BLOG7COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    10 Must-Have Features in a Successful Mobile App in the USA
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 26, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/best-mobile-banking-apps-in-usa')}
                >
                    <Box component="img" 
                    src={BLOG6COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Top 10 Mobile Banking Apps in USA for 2025 - OSTRYX
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 22, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/mobile-app-development-cost-usa')}
                >
                    <Box component="img" 
                    src={BLOG5COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Expert Guide on Mobile App Development Cost in USA
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 21, 2025
                    </Typography>
                    </Box>
                </Box>

                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/how-generative-ai-is-changing-software-development-2025')}
                >
                    <Box component="img" 
                    src={PROJECT1} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                        How Generative AI is Changing Software Development in 2025
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 15, 2025
                    </Typography>
                    </Box>
                </Box>

                {/* <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/creative-web-app-ideas-for-entrepreneurs')}
                >
                    <Box component="img" 
                    src={PROJECT3} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                        Creative Web App Ideas for Entrepreneurs
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 14, 2025
                    </Typography>
                    </Box>
                </Box>
                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/app-development-for-startups-strategies-2025')}
                >
                    <Box component="img" 
                    src={BLOG1COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    App Development for Startups - Important Strategies for 2025
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 9, 2025
                    </Typography>
                    </Box>
                </Box>
                <Box 
                    sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    alignItems: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        transition: 'background-color 0.3s ease'
                    }
                    }}
                    onClick={() => navigate('/key-factors-choosing-app-development-company-usa')}
                >
                    <Box component="img" 
                    src={BLOG2COVER} 
                    sx={{ 
                        width: '80px', 
                        height: '80px', 
                        borderRadius: '8px',
                        objectFit: 'cover'
                    }} 
                    />
                    <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    Key Factors to Consider When Choosing an App Development Company in the USA
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        April 9, 2025
                    </Typography>
                    </Box>
                </Box> */}
                </Box>
            </Box>
    );
};

export default RecentBlogs;
